export enum AgentType {
  INGEST_TRANSCRIPT_TASK = 'ingest_transcript_task',
  PROVIDER_FINDER = 'provider_finder',
  ARTIFACT_DIGEST = 'artifact_digest',
  BLAND_CALLER = 'bland_caller',
  SLACK_TASK_BOT = 'slack_task_bot',
  BLOB_SORTER = 'blob_sorter',
  FRONT_APP_INTEGRATION = 'front_app_integration',
  TASK_GENERATOR = 'task_generator',
  COVERAGE_EXTRACTOR = 'coverage_extractor',
  AIRTABLE_SYNC = 'airtable_sync',
  LOA_DETECTOR = 'loa_detector',
  RAINMAKER = 'rainmaker',
  SYSTEM = 'system', // default
}
